import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftexchangeComponent } from './simple-icons-microsoftexchange.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftexchangeComponent ],
    exports:      [ SimpleIconsMicrosoftexchangeComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftexchangeModule {}
